import { Seats } from "types/generated";

export enum UserManagementActivationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

type SettingsContextValueBase = {
  activationStatus: UserManagementActivationStatus;
  seats: Seats;
};

type SettingsContextValueNonAdmin = SettingsContextValueBase & {
  securityEmail: undefined;
};

type SettingsContextValueAdmin = SettingsContextValueBase & {
  securityEmail?: string;
};

export type SettingsContextValue = SettingsContextValueNonAdmin | SettingsContextValueAdmin;

export enum OrganizationAccessTabs {
  API_KEYS = "Api keys",
  SPACES = "Spaces",
  USERS = "Users",
  IDP_GROUP_MAPPING = "IdP group mapping",
  LOGIN_POLICIES = "Login policies",
  MANAGEMENT_STRATEGY = "Management strategy",
  ROLES = "Roles",
}

export enum OrganizationAuthTabs {
  SSO = "SSO",
  MFA = "MFA",
}

export enum OrganizationSecurityTabs {
  SECURITY_EMAIL = "Security email",
  SESSIONS = "Sessions",
  RUNTIME_SECURITY = "Runtime Security",
  OIDC_SUBJECT_TEMPLATE = "OIDC subject template",
}

export enum OrganizationAccountTabs {
  BILLING = "Billing",
  LIMITS = "Limits",
  USAGE = "Usage",
  USAGE_EXPORT = "Usage export",
  AI = "AI",
  ACCOUNT_DELETION = "Account deletion",
}

export enum ManagementStrategy {
  LOGIN_POLICY = "Login Policy",
  USER_MANAGEMENT = "User Management",
}
